import React, { Children } from 'react'
import { Carousel } from '../Carousel'
import MediaPromo from '../MediaPromo'

const CarouselList = ({ items, flavor }) => {
  return (
    <Carousel flavor={flavor} autoplay={items.length > 1} infinite={items.length > 1}>
      {Children.toArray(
        items.map((item) => (
          <MediaPromo
            promo={item}
            isGif
            buttonEmphasis="medium"
            endGutter
            noTooltip
            // there is a bug in the carousel library that we use that causes the zion image to never load
            eager
          />
        ))
      )}
    </Carousel>
  )
}

export default CarouselList
